import React, { useRef, useState } from 'react';
import { Fab, ClickAwayListener, MenuList, Box, Menu } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { gray, primary, white } from '../../constants/Colors';

//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    id?: string; // El id es opcional
    color?: string; // El color es opcional
    colorIcon?: string;
    colorHover?: string;
    textoBoton?: string; // El texto es opcional
    onClick?: () => void; // La función es opcional
    icon?: React.ReactNode | null;
}

function BotonRedondo({ id = "fab_button", color = primary, colorIcon = white, colorHover = gray, textoBoton = "", onClick = undefined, icon = <AddIcon /> }: Props) {
    const anchorRef = useRef<HTMLButtonElement>(null);

    const fabStyle = {
        backgroundColor: color, // reemplaza 'color' con el color que desees
        color: colorIcon, // reemplaza 'colorIcon' con el color que desees
        '&:hover': {
            backgroundColor: colorHover, // reemplaza 'newColor' con el color que desees al pasar el mouse sobre el botón
        },
    };

    return (
        <div>
            <Box id={id} display="flex" flexDirection="column" alignItems="center" justifyContent="flex-end">
                <Fab aria-label="add"
                    onClick={onClick}
                    aria-haspopup="true"
                    ref={anchorRef}
                    sx={fabStyle}>
                    {icon}
                </Fab>
            </Box>
        </div>
    );
}

export default BotonRedondo;